import { Link } from 'react-router-dom';

import CartHeaderIcon from '../../../../assets/icons/header/oneInformBar/cart.svg';
import { appConfig } from '../../../../config/app-config';
import Button from '../../../../shared/components/Button';

interface CartEmptyStateProps {
  storeKey?: string;
  eventKey?: string;
  isLoggedIn?: boolean;
  onLogin: () => void;
}

const CartEmptyState = ({ storeKey, eventKey, isLoggedIn, onLogin }: CartEmptyStateProps) => (
  <div className="w-full flex flex-col !justify-start p-6 bg-transparent min-h-0 overflow-x-hidden" style={{ minHeight: 'calc(100vh - 340px)' }}>
    <div className="w-full max-w-[1240px] mx-auto flex flex-col flex-grow">
      <div className="w-full flex justify-between items-baseline mb-[32px] bg-transparent rounded-none pb-3 shadow-none border-b-0">
        <h1 className="font-aleo text-[26px] font-semibold text-[#030407] leading-[32px] mb-2">
          Basket
        </h1>
        <Link
          to={`/${storeKey || appConfig.defaults.storeKey}/${eventKey}`}
          className="font-bold text-sm leading-5 tracking-[0px] text-[#030407] no-underline hover:text-gray-700"
        >
          View all passes
        </Link>
      </div>
      <div className="w-full max-w-[1240px] mx-auto p-12 text-center bg-transparent shadow-none flex-grow flex flex-col items-center justify-center">
        <div className="mb-[16px] w-[56px] h-[56px] bg-[#F2F4F7] rounded-full flex items-center justify-center">
          <img src={CartHeaderIcon} alt="Empty Basket" width="28" height="28" style={{ filter: 'brightness(0)' }} />
        </div>
        <div className="flex flex-col gap-[8px] items-center text-center">
          <h2 className="text-[18px] font-semibold text-[#030407] leading-[26px] font-noto">
            Your basket is empty
          </h2>
          <p className="text-[14px] font-normal text-[#667085] leading-[24px] font-noto">
            Passes you add will appear here.
          </p>
        </div>
        {!isLoggedIn && (
          <Button
            className="bg-[#030407] text-white hover:bg-gray-800 py-[10px] px-[18px] text-[14px] leading-[20px] font-bold rounded-lg transition-colors shadow-sm mt-[32px]"
            onClick={onLogin}
          >
            Log In
          </Button>
        )}
      </div>
    </div>
  </div>
);

export default CartEmptyState;
